import { render, staticRenderFns } from "./baseUploadFile.vue?vue&type=template&id=12c07d7b&scoped=true"
import script from "./baseUploadFile.vue?vue&type=script&lang=js"
export * from "./baseUploadFile.vue?vue&type=script&lang=js"
import style0 from "./baseUploadFile.vue?vue&type=style&index=0&id=12c07d7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c07d7b",
  null
  
)

export default component.exports